import axios from "axios";

import {IResponse} from "../Base/Base.types";
import {IAgentReview, IAgentSignup, IAgentSignupDocument} from "./AgentSignup.types";
import {BrowserUtils} from "../../utils/Browser";

export default class AgentSignupApi {
    static async postData({queryKey}: any) {
        //eslint-disable-next-line
        const [_, rawQuery] = queryKey;
        let fullQuery = {...rawQuery}
        try {
            await axios.post(`/AgentSubmission`, fullQuery);
            if (rawQuery.files) {
                await AgentSignupApi.uploadFiles(rawQuery.email, rawQuery.files);
            }
            return true;
        } catch (e: any) {
            console.error('Could not create agent signup: ', e.response.data);
            return {errors: e.response.data};
        }
    }

    static async updateData({queryKey}: any) {
        //eslint-disable-next-line
        const [_, rawQuery] = queryKey;
        let fullQuery = {...rawQuery}
        try {
            await axios.put(`/AgentSubmission`, fullQuery);
            if (rawQuery.files) {
                await AgentSignupApi.uploadFiles(rawQuery.email, rawQuery.files);
            }
            return true;
        } catch (e: any) {
            console.error('Could not update agent signup: ', e.response.data);
            return {errors: e.response.data};
        }
    }

    static async uploadFiles(agentEmail:string, files: File[]) {
        try {
            let formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                formData.append("files", file);
            }
            await axios.post(`/AgentSubmission/UploadFiles?agentEmail=${agentEmail}`, formData);
            return true;

        } catch (e: any) {
            console.error('Could not submit agent signup data: ', e.message);
            return undefined;
        }
    }

    static async getData({queryKey}: any) {
        //eslint-disable-next-line
        const [_, rawQuery] = queryKey;
        try {
            let res = await axios.get(`/AgentSubmission`, {params: rawQuery})
            return res.data as IAgentSignup;
        } catch (e: any) {
            console.error('Could not load agent signup data: ', e.message);
            return undefined;
        }
    }

    static async getDocuments({queryKey}: any) {
        //eslint-disable-next-line
        const [_, rawQuery] = queryKey;
        try {
            let res = await axios.get(`/AgentSubmission/LoadAgentSignupDocuments`, {params: rawQuery})
            return res.data as IAgentSignupDocument[];
        } catch (e: any) {
            console.error('Could not load agent signup data: ', e.message);
            return undefined;
        }
    }

    static async downloadDocument(docId:number, docName:string) {
        try {
            let res = await axios.get(`/AgentSubmission/DownloadAgentSignupDocument`, {params: {docId}, responseType: 'blob'})
            let blob = new Blob([res.data])
             const blobURL = window.URL.createObjectURL(blob);
            BrowserUtils.downloadFile(docName, blobURL);
            return res.data as any;
        } catch (e: any) {
            console.error('Could not load agent signup data: ', e.message);
            return undefined;
        }
    }

    static async getSearchData({queryKey}: any) {
        //eslint-disable-next-line
        const [_, rawQuery] = queryKey;
        try {
            let res = await axios.get(`/AgentSubmission/Search`, {params: rawQuery});
            return res.data as IResponse<IAgentReview>;
        } catch (e: any) {
            console.error('Could not get AgentReviewSearch data: ', e.message);
            return undefined;
        }
    }

    static async getDataById({queryKey}: any) {
        //eslint-disable-next-line
        const [_, agentID] = queryKey;
        try {
            let res = await axios.get(`/AgentSubmission/${agentID}`);
            return res.data as IAgentReview;
        } catch (e: any) {
            console.error('Could not get AgentReviewSearch data: ', e.message);
            return undefined;
        }
    }

    static async postAgentReviewData({queryKey}: any) {
        //eslint-disable-next-line
        const [_, rawQuery] = queryKey;

        try {
            await axios.post(`/AgentSubmission/SaveReview`, rawQuery);
            return true;
        } catch (e: any) {
            console.error('Could not update agent signup: ', e.response.data);
            return {errors: e.response.data};
        }
    }
}